import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ECOM_PLATFORM_APP_DEF_ID, PageMap } from '../../utils/consts';
import { addWhiteListParamsToUrl } from '../../utils/whiteListParams';
import { SPECS } from '../SPECS';
import { isValidHttpUrl } from '../../utils/isValidHttpUrl';
export class NavigationService {
  constructor(controllerConfig, options) {
    this.controllerConfig = controllerConfig;
    _defineProperty(this, "continueShoppingUrl", void 0);
    _defineProperty(this, "successUrl", void 0);
    _defineProperty(this, "experiments", void 0);
    this.continueShoppingUrl = options == null ? void 0 : options.continueShoppingUrl;
    this.successUrl = options == null ? void 0 : options.successUrl;
    this.experiments = options.experiments;
  }
  async getThankYouPageUrlForPlaceOrder() {
    if (this.experiments.enabled(SPECS.SupportSuccessUrlParamInCheckout) && this.successUrl && isValidHttpUrl(this.successUrl)) {
      return this.successUrl.replace('{objectType}', 'order');
    }
    const {
      url
    } = await this.getSectionUrl(PageMap.THANK_YOU_PAGE);
    const orderIdPlaceholder = 'orderIdPlaceholder';
    const thankYouPageUrl = new URL(url + "/" + orderIdPlaceholder);
    const appSectionParams = JSON.stringify({
      objectType: 'order',
      origin: 'checkout',
      ...(this.continueShoppingUrl && {
        continueShoppingUrl: this.continueShoppingUrl
      })
    });
    thankYouPageUrl.searchParams.set('appSectionParams', appSectionParams);
    addWhiteListParamsToUrl(thankYouPageUrl, this.controllerConfig.wixCodeApi.location.url);
    return thankYouPageUrl.toString().replace('orderIdPlaceholder', '{orderId}');
  }
  async getCheckoutErrorUrl(checkout, cashierPaymentId) {
    const checkoutErrorUrl = await this.getCheckoutUrl(checkout, cashierPaymentId);
    checkoutErrorUrl.searchParams.set('redirect', 'error');
    addWhiteListParamsToUrl(checkoutErrorUrl, this.controllerConfig.wixCodeApi.location.url);
    return checkoutErrorUrl.toString();
  }
  async getCheckoutCancelUrl(checkout, cashierPaymentId) {
    const checkoutCancelUrl = await this.getCheckoutUrl(checkout, cashierPaymentId);
    checkoutCancelUrl.searchParams.set('redirect', 'cancel');
    return checkoutCancelUrl.toString();
  }
  async navigateToThankYouPage(orderId) {
    var _this$controllerConfi, _this$controllerConfi2;
    if (this.experiments.enabled(SPECS.SupportSuccessUrlParamInCheckout) && this.successUrl && isValidHttpUrl(this.successUrl)) {
      return this.navigateToExternalSuccessPage(orderId);
    }
    const {
      url
    } = await this.getSectionUrl(PageMap.THANK_YOU_PAGE);
    const thankYouPageUrl = new URL(url + "/" + orderId);
    thankYouPageUrl.searchParams.set('appSectionParams', JSON.stringify({
      objectType: 'order',
      origin: 'cashier-express-directly-to-typ',
      ...(this.continueShoppingUrl && {
        continueShoppingUrl: this.continueShoppingUrl
      })
    }));
    return (_this$controllerConfi = (_this$controllerConfi2 = this.controllerConfig.wixCodeApi.location).to) == null ? void 0 : _this$controllerConfi.call(_this$controllerConfi2, thankYouPageUrl.toString());
  }
  async navigateToExternalSuccessPage(orderId) {
    var _this$controllerConfi3, _this$controllerConfi4;
    const externalSuccessUrl = this.successUrl.replace('{orderId}', orderId).replace('{objectType}', 'order');
    return (_this$controllerConfi3 = (_this$controllerConfi4 = this.controllerConfig.wixCodeApi.location).to) == null ? void 0 : _this$controllerConfi3.call(_this$controllerConfi4, externalSuccessUrl);
  }
  async getCheckoutUrl(_ref, cashierPaymentId) {
    var _shippingInfo$selecte;
    let {
      cartId,
      id,
      shippingInfo
    } = _ref;
    const {
      url
    } = await this.getSectionUrl(PageMap.CHECKOUT);
    const isPickupFlow = this.experiments.enabled(SPECS.AddIsPickupFlowToCheckoutUrl) && (shippingInfo == null || (_shippingInfo$selecte = shippingInfo.selectedCarrierServiceOption) == null || (_shippingInfo$selecte = _shippingInfo$selecte.logistics) == null ? void 0 : _shippingInfo$selecte.pickupDetails);
    const checkoutUrl = new URL(url);
    checkoutUrl.searchParams.set('appSectionParams', JSON.stringify({
      checkoutId: id,
      ...(isPickupFlow && {
        isPickupFlow: 'true'
      }),
      ...(cartId && {
        cartId
      }),
      ...(this.continueShoppingUrl && {
        continueShoppingUrl: this.continueShoppingUrl
      }),
      ...(this.successUrl && {
        successUrl: this.successUrl.replace('{objectType}', 'order')
      }),
      cashierPaymentId
    }));
    checkoutUrl.searchParams.set('checkoutOOI', 'true');
    addWhiteListParamsToUrl(checkoutUrl, this.controllerConfig.wixCodeApi.location.url);
    return checkoutUrl;
  }
  async navigateToCheckout(checkout, cashierPaymentId) {
    var _this$controllerConfi5, _this$controllerConfi6;
    const checkoutUrl = await this.getCheckoutUrl(checkout, cashierPaymentId);
    return (_this$controllerConfi5 = (_this$controllerConfi6 = this.controllerConfig.wixCodeApi.location).to) == null ? void 0 : _this$controllerConfi5.call(_this$controllerConfi6, checkoutUrl.toString());
  }
  getSectionUrl(sectionId) {
    const params = {
      sectionId,
      appDefinitionId: ECOM_PLATFORM_APP_DEF_ID
    };
    return this.controllerConfig.wixCodeApi.site.getSectionUrl(params, false);
  }
}
//# sourceMappingURL=NavigationService.js.map